"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseLicenseCompactDetailsDto = instanceOfNurseLicenseCompactDetailsDto;
exports.NurseLicenseCompactDetailsDtoFromJSON = NurseLicenseCompactDetailsDtoFromJSON;
exports.NurseLicenseCompactDetailsDtoFromJSONTyped = NurseLicenseCompactDetailsDtoFromJSONTyped;
exports.NurseLicenseCompactDetailsDtoToJSON = NurseLicenseCompactDetailsDtoToJSON;
exports.NurseLicenseCompactDetailsDtoToJSONTyped = NurseLicenseCompactDetailsDtoToJSONTyped;
const JurisdictionDto_1 = require("./JurisdictionDto");
/**
 * Check if a given object implements the NurseLicenseCompactDetailsDto interface.
 */
function instanceOfNurseLicenseCompactDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined)
        return false;
    if (!('jurisdictions' in value) || value['jurisdictions'] === undefined)
        return false;
    return true;
}
function NurseLicenseCompactDetailsDtoFromJSON(json) {
    return NurseLicenseCompactDetailsDtoFromJSONTyped(json, false);
}
function NurseLicenseCompactDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
        'jurisdictions': (json['jurisdictions'].map(JurisdictionDto_1.JurisdictionDtoFromJSON)),
    };
}
function NurseLicenseCompactDetailsDtoToJSON(json) {
    return NurseLicenseCompactDetailsDtoToJSONTyped(json, false);
}
function NurseLicenseCompactDetailsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
        'jurisdictions': (value['jurisdictions'].map(JurisdictionDto_1.JurisdictionDtoToJSON)),
    };
}
//# sourceMappingURL=NurseLicenseCompactDetailsDto.js.map